import { fetchWrapper } from ".";

export const getOutbid = () =>
  fetchWrapper(
    "GET",
    "/outbid?chainIds=" +
      process.env.REACT_APP_OUTBID_CHAIN_IDS +
      (process.env.REACT_APP_SUB_MODE ? "&env=" + process.env.REACT_APP_SUB_MODE.toLowerCase() : ""),
    undefined,
    undefined,
    undefined,
    true
  );

export const getOutbidSaleBidTable = (outbidAddress, saleAddress) => {
  let queryString = "";
  if (outbidAddress) queryString += "?outbidAddress=" + outbidAddress;
  if (saleAddress) queryString += "&saleAddress=" + saleAddress;
  return fetchWrapper("GET", "/outbid/saleBidTable" + queryString, undefined, undefined, undefined, true);
};

export const postOutbidTxs = txHash =>
  fetchWrapper(
    "POST",
    "/misc/postTx",
    {
      txHash,
      chainID: process.env.REACT_APP_OUTBID_CHAIN_IDS,
    },
    undefined,
    undefined,
    true
  );
